import React from "react";
import { withI18n } from "react-i18next";
import styled from "styled-components";

interface IProps {
  t?: any;
}

// SVG Icon Components
const MonitorIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
    <line x1="8" y1="21" x2="16" y2="21"></line>
    <line x1="12" y1="17" x2="12" y2="21"></line>
  </svg>
);

const GlobeIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"></circle>
    <line x1="2" y1="12" x2="22" y2="12"></line>
    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
  </svg>
);

const UploadIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
    <polyline points="17 8 12 3 7 8"></polyline>
    <line x1="12" y1="3" x2="12" y2="15"></line>
  </svg>
);

const DevicesIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="5" y="2" width="14" height="20" rx="2" ry="2"></rect>
    <line x1="12" y1="18" x2="12.01" y2="18"></line>
  </svg>
);

const PlayIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="2" width="20" height="20" rx="2.18" ry="2.18"></rect>
    <polygon points="10 8 16 12 10 16 10 8" fill="currentColor"></polygon>
  </svg>
);

const SearchPeopleIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
    <circle cx="9" cy="7" r="4"></circle>
    <circle cx="19" cy="11" r="3"></circle>
    <line x1="19" y1="8" x2="19" y2="14"></line>
    <line x1="16" y1="11" x2="22" y2="11"></line>
  </svg>
);

const TalentSellingFeatures: React.FC<IProps> = ({ t }) => {
  const features = [
    {
      icon: <MonitorIcon />,
      text: t("Access new casting notices and breakdowns every day")
    },
    {
      icon: <GlobeIcon />,
      text: t("Join a global network of millions of actors")
    },
    {
      icon: <UploadIcon />,
      text: t("Create and upload your online portfolio in minutes")
    },
    {
      icon: <DevicesIcon />,
      text: t("Submit for roles anytime, on mobile or desktop")
    },
    {
      icon: <PlayIcon />,
      text: t("Edit your demo reel with built-in tools and upload up to 5 hours of HD footage")
    },
    {
      icon: <SearchPeopleIcon />,
      text: t("Find agents and connect with industry professionals on the platform")
    }
  ];

  return (
    <Wrapper>
      <Title>{t("Try theWorkbook Pro Membership for Free")}</Title>
      <FeatureList>
        {features.map((feature, index) => (
          <FeatureItem key={index}>
            <IconWrapper>{feature.icon}</IconWrapper>
            <FeatureText>{feature.text}</FeatureText>
          </FeatureItem>
        ))}
      </FeatureList>
    </Wrapper>
  );
};

export default withI18n()(TalentSellingFeatures);

const Wrapper = styled.div`
  width: 100%;
  max-width: 550px;
  padding: 0 0px;
`;

const Title = styled.h3`
  font-size: 18px;
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 24px 0;

  @media all and (max-width: 520px) {
    font-size: 16px;
    margin-bottom: 16px;
  }
`;

const FeatureList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const FeatureItem = styled.li`
  display: flex;
  align-items: flex-start;
  margin-bottom: 12px;

  @media all and (max-width: 520px) {
    margin-bottom: 10px;
  }
`;

const IconWrapper = styled.div`
  color: #ffffff;
  margin-right: 12px;
  flex-shrink: 0;
  margin-top: 2px;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 20px;
    height: 20px;
  }

  @media all and (max-width: 520px) {
    svg {
      width: 18px;
      height: 18px;
    }
  }
`;

const FeatureText = styled.span`
  font-size: 14px;
  color: #ffffff;
  line-height: 1.5;

  @media all and (max-width: 520px) {
    font-size: 13px;
  }
`;
